import Table from 'react-bootstrap/Table'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'

const getStripeAccountScopeLabel = (stripeAccountScope) =>
  stripeAccountScope === 'platform' ? 'Platform' : 'Connected account'

export default function ReadersTable({
  readers,
  locations,
  terminalConfig,
  handleShowReaderModal,
}) {
  const getLocationName = (locationId) => {
    const location = locations.find((loc) => loc.location_id === locationId)
    return location?.displayName || locationId
  }

  return (
    <>
      {!locations?.length ? (
        <Alert variant="warning" className="mb-3">
          Create at least one location before registering a reader.
        </Alert>
      ) : null}

      <Row className="justify-content-md-end mb-3">
        <Col md="auto">
          <Button
            variant="primary"
            disabled={!locations?.length}
            onClick={() => handleShowReaderModal()}
          >
            Add Reader
          </Button>
        </Col>
      </Row>
      {readers && readers.length > 0 ? (
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Label</th>
              <th>Location</th>
              <th>Stripe account</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {readers.map((reader) => (
              <tr key={reader.id || reader.stripeReaderId}>
                <td>{reader?.label}</td>
                <td>{getLocationName(reader.location)}</td>
                <td>
                  {getStripeAccountScopeLabel(
                    reader?.stripeAccountScope ||
                      terminalConfig?.stripeAccountScope
                  )}
                </td>
                <td onClick={() => handleShowReaderModal(reader)}>
                  <Button variant="link">Edit</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <Alert variant="light" className="mb-0">
          No readers yet.
        </Alert>
      )}
    </>
  )
}
